(() => {
    'use strict';

    // Init event handlers globally for all assignment widgets.
    howspace.commentsTrait.attachEventHandlers('assignment');

    const postPrompt = (widget, prompt) => {
        real.ajax.json(real.baseUri + '/api/ai/prompt/widget', {
            type: 'POST',
            data: JSON.stringify({
                context: {
                    'widget_type': widget.data('widget-type'),
                    'widget_id': widget.data('widget-id')
                },
                prompt: prompt
            }),
            success: () => {
                howspace.aiGen.setPromptTimeout(widget);
            },
            error: () => {
                real.notification.show(howspace.translate('widget_prompt_failed'), 'danger');
                real.button.reset(widget.find('.prompt-btn'), widget.find('.prompt-container'));
            }
        });
    };

    howspace.widgets.assignment = {
        initView: widget => {
            // Component handlers.
            howspace.commentsTrait.attachComponentHandlers(widget);

            const renderFeedback = notification => {
                const comment = widget.find('.comment[data-id="' + notification.object.comment.id + '"]');
                if (!comment.length) {
                    return;
                }

                const feedbackContainer = comment.find('.comment-feedback-container');
                const oldFeedback = feedbackContainer.find('.comment-feedback');

                // Clone the old feedback, update its HTML, hide it and append to container.
                let newFeedback;
                if (notification.object.feedback?.result_html) {
                    newFeedback = $(notification.object.feedback.result_html);
                } else {
                    newFeedback = $('<span class="text-danger">').text(notification.object.error);
                }
                newFeedback.hide();
                feedbackContainer.append(newFeedback);

                real.animator()
                    .setParentElement(feedbackContainer)
                    .setHideElement(oldFeedback)
                    .setShowElement(newFeedback)
                    .setAnimDuration(350)
                    .onHideReady(() => {
                        oldFeedback.remove();
                    })
                    .onShowReady(() => {
                        howspace.components.init(feedbackContainer);
                    }).startAnimation();
            };

            real.events.on('assignment:comment:feedback:updated', notification => {
                renderFeedback(notification);
            });

            real.events.on('assignment:comment:feedback:progress', notification => {
                renderFeedback(notification);
            });

            real.events.on('assignment:comment:feedback:failed', notification => {
                renderFeedback(notification);
            });

            widget.on('click', '.close-prompt-response-btn', () => {
                widget.find('.prompt-widget-btn').trigger('click');
            });

            widget.on(howspace.components.collapse.EXPANDED, '.prompt-container', () => {
                widget.find('.prompt-input').focus();
            });

            widget.on('click', '.prompt-btn', (e) => {
                const btn = $(e.target);
                if (widget.data('number-of-comments') === 0) {
                    // Don't try to prompt if there are no comments.
                    return;
                }
                const promptInput = widget.find('.prompt-input');
                real.button.loading(btn, widget.find('.prompt-container'));
                postPrompt(widget, promptInput.val().trim());
            });

            widget.find('.prompt-input').on('keydown', (e) => {
                if (e.key === 'Enter') {
                    widget.find('.prompt-btn').trigger('click');
                }
            });

            widget.find('.copy-result-to-clipboard-btn').on('click', async (e) => {
                const btn = $(e.target);
                const wrapper = btn.closest('.prompt-input-wrapper');
                let promptResult = wrapper.find('.prompt-result ul');
                if (promptResult.length === 0) {
                    promptResult = wrapper.find('.prompt-result');
                }
                await real.copyToClipboard(promptResult, () => {
                    real.notification.show(howspace.translate('assignment_ai_response_copied_to_clipboard'), 'success');
                }, () => {
                    real.notification.show(howspace.translate('assignment_ai_response_copy_to_clipboard_failed'), 'danger');
                });
            });

            return new Promise((resolve) => {
                widget.one(howspace.components.lister.LIST_ITEMS_RENDERED, resolve);
            });
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Empty for now.
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        updateFilter: howspace.commentsTrait.reloadComments,
        initEvaluationModal: (modal, modalOpener) => {
            const comment = $(modalOpener).closest('.comment');

            modal = $(modal);

            modal.on('focus input', 'input,textarea,select', function () {
                // Grading field focused or textarea value changed.
                $(this).closest('.grading-field').find('.grading-field-icon').addClass('d-none');
            });

            modal.find('.howspace-form-select').on('change', e => {
                const select = $(e.target);
                const gradingFieldClass = select.find('option:selected').data('select-class');
                select.removeClass('is-passed').removeClass('is-failed').addClass(gradingFieldClass);
            })

            modal.find('.howspace-form-number-input').on('change', e => {
                const input = $(e.target);
                const passingValue = input.data('passing-value');
                const value = input.val();
                let gradingFieldClass = '';
                if (value !== '') {
                    gradingFieldClass = parseInt(value) >= passingValue ? 'is-passed' : 'is-failed';
                }
                input.removeClass('is-passed').removeClass('is-failed').addClass(gradingFieldClass);
            })

            modal.find('.btn-success').on('click', async () => {
                let evaluated = true;
                let error = false;

                const inputs = modal.find('input,textarea,select');
                const promises = inputs.map(async function () {
                    const input = $(this);
                    if (!input.val()) {
                        evaluated = false;
                    }

                    try {
                        await howspace.evaluation.saveGradingResult(input);
                    } catch (err) {
                        error = true;
                    }
                }).get();

                await Promise.all(promises);

                if (error) {
                    return;
                }

                if (evaluated) {
                    comment.find('.badge-evaluated').removeClass('d-none');
                } else {
                    comment.find('.badge-evaluated').addClass('d-none');
                }

                howspace.components.modal.close(modal);
            });
        }
    };
})();
